import React from 'react'

import Theme from '../../atoms/Theme'

import Navbar from '../../organisms/Navbar'
import Footer from '../../organisms/Footer'

import Main from './Main'
import Page from './Page'

export default ({ trackingData, menu, logo, footer, navMenu, ...props }) => (
  <Theme>
    <Page trackingData={trackingData}>
      <Navbar {...{ menu, logo }}>{navMenu}</Navbar>
      <Main {...props} />
      <Footer {...footer} />
    </Page>
  </Theme>
)
